import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { OverlayLoader } from './OverlayLoader';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 'auto',
    marginBottom: 'auto',
    position: 'relative',
  },
}));

export const OverlayTableContainer: React.FC = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <OverlayLoader />
    </div>
  );
};
